export default "__VITE_ASSET__BUzIBz$s__"